var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"fixed inset-0 z-50 isolate h-full w-full flex flex-col items-center justify-end sm:justify-center",class:{ 'bg-gray-500/20': _vm.showScrim }},[_c('div',{staticClass:"bg-white rounded-t-3xl sm:rounded-t-2xl sm:rounded-b-2xl shadow-xl w-full sm:max-w-screen-md sm:min-w-36 overflow-y-auto max-h-full sm:max-h-screen-90",class:{
      'min-h-[80vh] sm:min-h-0': !_vm.fullHeightInMobile,
      'min-h-full sm:min-h-0': _vm.fullHeightInMobile,
    }},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }